/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Platform API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  BatchQueryParams
} from '../../../types/platform/batchQueryParams';

import type {
  BatchQueryRequest
} from '../../../types/platform/batchQueryRequest';

import type {
  ExecuteQueryParams
} from '../../../types/platform/executeQueryParams';

import type {
  ExportQueryParams
} from '../../../types/platform/exportQueryParams';

import type {
  HumaAPIError
} from '../../../types/platform/humaAPIError';

import type {
  MetricsPlanResponse
} from '../../../types/platform/metricsPlanResponse';

import type {
  MetricsQueryParams
} from '../../../types/platform/metricsQueryParams';

import type {
  MetricsRequest
} from '../../../types/platform/metricsRequest';

import type {
  MetricsResponse
} from '../../../types/platform/metricsResponse';

import type {
  PlanResponse
} from '../../../types/platform/planResponse';

import type {
  QueryPermissionsResponse
} from '../../../types/platform/queryPermissionsResponse';

import type {
  QueryRequest
} from '../../../types/platform/queryRequest';

import type {
  QueryResponse
} from '../../../types/platform/queryResponse';

import { customFetch } from '../../../../src/custom-fetch';
import type { ErrorType } from '../../../../src/custom-fetch';

interface TypedResponse<T> extends Response {
  json(): Promise<T>;
}


export type HTTPStatusCode1xx = 100 | 101 | 102 | 103;
export type HTTPStatusCode2xx = 200 | 201 | 202 | 203 | 204 | 205 | 206 | 207;
export type HTTPStatusCode3xx = 300 | 301 | 302 | 303 | 304 | 305 | 307 | 308;
export type HTTPStatusCode4xx = 400 | 401 | 402 | 403 | 404 | 405 | 406 | 407 | 408 | 409 | 410 | 411 | 412 | 413 | 414 | 415 | 416 | 417 | 418 | 419 | 420 | 421 | 422 | 423 | 424 | 426 | 428 | 429 | 431 | 451;
export type HTTPStatusCode5xx = 500 | 501 | 502 | 503 | 504 | 505 | 507 | 511;
export type HTTPStatusCodes = HTTPStatusCode1xx | HTTPStatusCode2xx | HTTPStatusCode3xx | HTTPStatusCode4xx | HTTPStatusCode5xx;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export type batchQueryResponse200 = {
  stream: TypedResponse<Blob>
  status: 200
}

export type batchQueryResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type batchQueryResponseSuccess = (batchQueryResponse200) & {
  headers: Headers;
};
export type batchQueryResponseError = (batchQueryResponseDefault) & {
  headers: Headers;
};

export type batchQueryResponse = batchQueryResponseSuccess

export const getBatchQueryUrl = (params?: BatchQueryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/sorm/batch-query?${stringifiedParams}` : `/auth/v1/sorm/batch-query`
}

/**
 * Executes multiple SORM queries concurrently and streams the results as newline-delimited JSON (NDJSON). Each input query carries a client-assigned id; each output line echoes that id with either a response or a per-query error. A per-query semantic failure (e.g. unknown entity or field, scope mismatch, a pivot-shape error with code INSTANCE_FIELD_ERROR, execution error) is isolated: it streams as that query's NDJSON error line and does not fail the rest of the batch, so the overall status stays 200. Two classes of problem instead reject the whole request up front with a JSON error body (no NDJSON): request-level problems (empty queries array, missing id, duplicate id) return 400 with error_details.code of EMPTY_BATCH, MISSING_ID, or DUPLICATE_ID; and a query whose body fails request-body schema validation (e.g. an invalid enum value) returns 422 and fails the entire batch before any query runs. Consumers should handle that 422 case in addition to the per-query error lines. The successful response body uses HTTP/1.1 chunked transfer encoding; clients should process lines as they arrive.
 * @summary Execute multiple queries and stream NDJSON results
 */
export const batchQuery = async (batchQueryRequest: BatchQueryRequest,
    params?: BatchQueryParams, options?: Parameters<typeof customFetch>[1]): Promise<batchQueryResponse> => {

  return customFetch<batchQueryResponse>(getBatchQueryUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(batchQueryRequest)
  }
);}





export const getBatchQueryMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof batchQuery>>, TError,{data: BatchQueryRequest;params?: BatchQueryParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof batchQuery>>, TError,{data: BatchQueryRequest;params?: BatchQueryParams}, TContext> => {

const mutationKey = ['batchQuery'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof batchQuery>>, {data: BatchQueryRequest;params?: BatchQueryParams}> = (props) => {
          const {data,params} = props ?? {};

          return  batchQuery(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BatchQueryMutationResult = NonNullable<Awaited<ReturnType<typeof batchQuery>>>
    export type BatchQueryMutationBody = BatchQueryRequest
    export type BatchQueryMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Execute multiple queries and stream NDJSON results
 */
export const useBatchQuery = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof batchQuery>>, TError,{data: BatchQueryRequest;params?: BatchQueryParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof batchQuery>>,
        TError,
        {data: BatchQueryRequest;params?: BatchQueryParams},
        TContext
      > => {
      return useMutation(getBatchQueryMutationOptions(options), queryClient);
    }
    export type exportQueryResponse200 = {
  data: Blob
  status: 200
}

export type exportQueryResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type exportQueryResponseSuccess = (exportQueryResponse200) & {
  headers: Headers;
};
export type exportQueryResponseError = (exportQueryResponseDefault) & {
  headers: Headers;
};

export type exportQueryResponse = exportQueryResponseSuccess

export const getExportQueryUrl = (params?: ExportQueryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/sorm/export?${stringifiedParams}` : `/auth/v1/sorm/export`
}

/**
 * Streams every row matching the query as CSV. Same request body as /auth/v1/sorm/query (limit and offset are ignored — the export streams up to the server-side cap of 10,000,000 rows).
 *
 * Response: the body is a CSV document streamed with HTTP/1.1 chunked transfer encoding (Transfer-Encoding: chunked). The first row contains schema field descriptions and the second row is the visible UI column header; data begins on the third row. Clients should not buffer the full body in memory before processing. An object-typed (json_payload) column is emitted as one cell of compact JSON, parsed and projected against the schema registered for that row's discriminator — the same object /auth/v1/sorm/query returns. A payload that cannot be shaped (unregistered discriminator value, invalid JSON, schema mismatch) renders that one cell blank and the export continues, where /query fails the whole request. Response headers: Content-Type: text/csv; charset=utf-8; Content-Disposition: attachment; filename="export-<root_entity>-<UTC-timestamp>.csv"; Vary: Accept-Encoding; and Content-Encoding: gzip when (and only when) the request sent Accept-Encoding: gzip.
 *
 * Errors: failures raised before any bytes are written (body decoding, parsing, planning, RLS, the oversize pre-flight count, multi-subplan rejection, pivot-shape failures) are returned as a JSON error with the appropriate 4xx/5xx status and an error_details.code of SEARCH_STRING_TOO_LARGE, MULTI_SUBPLAN_NOT_SUPPORTED, EXPORT_TOO_LARGE, INSTANCE_FIELD_ERROR, MULTIPLE_FAN_OUT_PATHS, REQUEST_PARAM_ERROR, or a parser/planner-specific code. Once the response body has started, the status is locked at 200 and any mid-stream failure truncates the CSV — no in-band error envelope is emitted.
 *
 * Limitations: plans that require multi-subplan stitching (chasm-trap resolution) are rejected with MULTI_SUBPLAN_NOT_SUPPORTED because streaming across stitched subplans would require buffering. A pre-flight row count above 10,000,000 is rejected with EXPORT_TOO_LARGE — narrow the query with filters and retry.
 *
 * Fan-out grain: expand_one_to_many streams the raw LEFT-JOIN grain (one CSV row per one_to_many child row, plus one NULL-padded row — blank cells — per root row with no children). The pre-flight count and the 10,000,000-row cap apply at that grain. The query may reach at most one one_to_many relationship (MULTIPLE_FAN_OUT_PATHS otherwise), and groups or per-field aggregation are rejected with VALIDATION_ERROR before the export lowering that would otherwise flatten them.
 * @summary Stream query results as CSV
 */
export const exportQuery = async (queryRequest: QueryRequest,
    params?: ExportQueryParams, options?: Parameters<typeof customFetch>[1]): Promise<exportQueryResponse> => {

  return customFetch<exportQueryResponse>(getExportQueryUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(queryRequest)
  }
);}





export const getExportQueryMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportQuery>>, TError,{data: QueryRequest;params?: ExportQueryParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof exportQuery>>, TError,{data: QueryRequest;params?: ExportQueryParams}, TContext> => {

const mutationKey = ['exportQuery'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof exportQuery>>, {data: QueryRequest;params?: ExportQueryParams}> = (props) => {
          const {data,params} = props ?? {};

          return  exportQuery(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ExportQueryMutationResult = NonNullable<Awaited<ReturnType<typeof exportQuery>>>
    export type ExportQueryMutationBody = QueryRequest
    export type ExportQueryMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Stream query results as CSV
 */
export const useExportQuery = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportQuery>>, TError,{data: QueryRequest;params?: ExportQueryParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof exportQuery>>,
        TError,
        {data: QueryRequest;params?: ExportQueryParams},
        TContext
      > => {
      return useMutation(getExportQueryMutationOptions(options), queryClient);
    }
    export type metricsQueryResponse200 = {
  data: MetricsResponse
  status: 200
}

export type metricsQueryResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type metricsQueryResponseSuccess = (metricsQueryResponse200) & {
  headers: Headers;
};
export type metricsQueryResponseError = (metricsQueryResponseDefault) & {
  headers: Headers;
};

export type metricsQueryResponse = metricsQueryResponseSuccess

export const getMetricsQueryUrl = (params?: MetricsQueryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/sorm/metrics?${stringifiedParams}` : `/auth/v1/sorm/metrics`
}

/**
 * Computes single-value statistics and distributions over one filtered universe — the same root entity, filters, search and drill-down scope a /auth/v1/sorm/query request carries, with no fields, grouping or page of its own. Nothing is grouped: groups is read only so scope entries can be checked against the group keys they replay.
 *
 * Each widget carries an id, unique across both lists, that keys its result. A widget that cannot be served — an unknown field, an aggregation its field does not take, a histogram whose entity is neither the root nor a dimension of it — is reported under that id in errors and every other widget is still served, so a partial answer returns 200.
 *
 * A histogram over a numeric or date field is binned; over a string or boolean field it returns the top values by count, with the rest summed into other_count. Binning is automatic unless the request pins it: about ten round buckets over the observed range, whose resolved width and anchor come back in bucket so a client can pin exactly those buckets on a later request. Every bucket is half-open over [start, end); buckets no row landed in are returned with a zero count, and NULL values are never a bucket — they are counted in null_count. A binned histogram that spans more than 500 buckets is rejected with BUCKET_LIMIT_EXCEEDED rather than truncated.
 *
 * A histogram field may sit on an entity FINER than the root — positions of the accounts an Account view admits — in which case it counts those rows, scoped to the universe, at their own grain.
 *
 * A histogram may name a weight: a numeric measure of the entity it counts, summed per bucket. Every bucket then reports weight and weight_share beside count and share, the histogram reports total_weight and null_weight, and a top-values histogram ranks its values by weight and sums the rest into other_weight. Weights are decimal strings. The weight has to sit on the counted entity itself so its sum stays at the grain the bucket counts.
 * @summary Compute statistics and histograms over a query's universe
 */
export const metricsQuery = async (metricsRequest: MetricsRequest,
    params?: MetricsQueryParams, options?: Parameters<typeof customFetch>[1]): Promise<metricsQueryResponse> => {

  return customFetch<metricsQueryResponse>(getMetricsQueryUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(metricsRequest)
  }
);}





export const getMetricsQueryMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof metricsQuery>>, TError,{data: MetricsRequest;params?: MetricsQueryParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof metricsQuery>>, TError,{data: MetricsRequest;params?: MetricsQueryParams}, TContext> => {

const mutationKey = ['metricsQuery'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof metricsQuery>>, {data: MetricsRequest;params?: MetricsQueryParams}> = (props) => {
          const {data,params} = props ?? {};

          return  metricsQuery(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MetricsQueryMutationResult = NonNullable<Awaited<ReturnType<typeof metricsQuery>>>
    export type MetricsQueryMutationBody = MetricsRequest
    export type MetricsQueryMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Compute statistics and histograms over a query's universe
 */
export const useMetricsQuery = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof metricsQuery>>, TError,{data: MetricsRequest;params?: MetricsQueryParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof metricsQuery>>,
        TError,
        {data: MetricsRequest;params?: MetricsQueryParams},
        TContext
      > => {
      return useMutation(getMetricsQueryMutationOptions(options), queryClient);
    }
    export type planMetricsResponse200 = {
  data: MetricsPlanResponse
  status: 200
}

export type planMetricsResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type planMetricsResponseSuccess = (planMetricsResponse200) & {
  headers: Headers;
};
export type planMetricsResponseError = (planMetricsResponseDefault) & {
  headers: Headers;
};

export type planMetricsResponse = planMetricsResponseSuccess

export const getPlanMetricsUrl = () => {




  return `/auth/v1/sorm/metrics/plan`
}

/**
 * Lowers the body /auth/v1/sorm/metrics takes into the statements it would run and returns them with their SQL, in execution order, executing none. An automatic histogram's own statement is the one a plan cannot show — its width is resolved from the extents statement listed before it — so it carries a note in place of SQL. A widget that cannot be planned is reported under its id in errors, exactly as /metrics reports it.
 * @summary Plan a metrics request without executing it (dry run)
 */
export const planMetrics = async (metricsRequest: MetricsRequest, options?: Parameters<typeof customFetch>[1]): Promise<planMetricsResponse> => {

  return customFetch<planMetricsResponse>(getPlanMetricsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(metricsRequest)
  }
);}





export const getPlanMetricsMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof planMetrics>>, TError,{data: MetricsRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof planMetrics>>, TError,{data: MetricsRequest}, TContext> => {

const mutationKey = ['planMetrics'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof planMetrics>>, {data: MetricsRequest}> = (props) => {
          const {data} = props ?? {};

          return  planMetrics(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlanMetricsMutationResult = NonNullable<Awaited<ReturnType<typeof planMetrics>>>
    export type PlanMetricsMutationBody = MetricsRequest
    export type PlanMetricsMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Plan a metrics request without executing it (dry run)
 */
export const usePlanMetrics = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof planMetrics>>, TError,{data: MetricsRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof planMetrics>>,
        TError,
        {data: MetricsRequest},
        TContext
      > => {
      return useMutation(getPlanMetricsMutationOptions(options), queryClient);
    }
    export type metricsQueryPermissionsResponse200 = {
  data: QueryPermissionsResponse
  status: 200
}

export type metricsQueryPermissionsResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type metricsQueryPermissionsResponseSuccess = (metricsQueryPermissionsResponse200) & {
  headers: Headers;
};
export type metricsQueryPermissionsResponseError = (metricsQueryPermissionsResponseDefault) & {
  headers: Headers;
};

export type metricsQueryPermissionsResponse = metricsQueryPermissionsResponseSuccess

export const getMetricsQueryPermissionsUrl = () => {




  return `/auth/v1/sorm/metrics/query-permissions`
}

/**
 * Accepts the same body as /auth/v1/sorm/metrics and reports missing schema permissions across all requested widgets, including automatic histogram measures and weights. No query is executed and no SQL is returned. Invalid widgets and planning failures remain errors; data-dependent bucket limits and row-level access are not checked.
 * @summary Report missing metrics query permissions
 */
export const metricsQueryPermissions = async (metricsRequest: MetricsRequest, options?: Parameters<typeof customFetch>[1]): Promise<metricsQueryPermissionsResponse> => {

  return customFetch<metricsQueryPermissionsResponse>(getMetricsQueryPermissionsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(metricsRequest)
  }
);}





export const getMetricsQueryPermissionsMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof metricsQueryPermissions>>, TError,{data: MetricsRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof metricsQueryPermissions>>, TError,{data: MetricsRequest}, TContext> => {

const mutationKey = ['metricsQueryPermissions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof metricsQueryPermissions>>, {data: MetricsRequest}> = (props) => {
          const {data} = props ?? {};

          return  metricsQueryPermissions(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MetricsQueryPermissionsMutationResult = NonNullable<Awaited<ReturnType<typeof metricsQueryPermissions>>>
    export type MetricsQueryPermissionsMutationBody = MetricsRequest
    export type MetricsQueryPermissionsMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Report missing metrics query permissions
 */
export const useMetricsQueryPermissions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof metricsQueryPermissions>>, TError,{data: MetricsRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof metricsQueryPermissions>>,
        TError,
        {data: MetricsRequest},
        TContext
      > => {
      return useMutation(getMetricsQueryPermissionsMutationOptions(options), queryClient);
    }
    export type planQueryResponse200 = {
  data: PlanResponse
  status: 200
}

export type planQueryResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type planQueryResponseSuccess = (planQueryResponse200) & {
  headers: Headers;
};
export type planQueryResponseError = (planQueryResponseDefault) & {
  headers: Headers;
};

export type planQueryResponse = planQueryResponseSuccess

export const getPlanQueryUrl = () => {




  return `/auth/v1/sorm/plan`
}

/**
 * @summary Generate query plan (dry run)
 */
export const planQuery = async (queryRequest: QueryRequest, options?: Parameters<typeof customFetch>[1]): Promise<planQueryResponse> => {

  return customFetch<planQueryResponse>(getPlanQueryUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(queryRequest)
  }
);}





export const getPlanQueryMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof planQuery>>, TError,{data: QueryRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof planQuery>>, TError,{data: QueryRequest}, TContext> => {

const mutationKey = ['planQuery'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof planQuery>>, {data: QueryRequest}> = (props) => {
          const {data} = props ?? {};

          return  planQuery(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PlanQueryMutationResult = NonNullable<Awaited<ReturnType<typeof planQuery>>>
    export type PlanQueryMutationBody = QueryRequest
    export type PlanQueryMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Generate query plan (dry run)
 */
export const usePlanQuery = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof planQuery>>, TError,{data: QueryRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof planQuery>>,
        TError,
        {data: QueryRequest},
        TContext
      > => {
      return useMutation(getPlanQueryMutationOptions(options), queryClient);
    }
    export type executeQueryResponse200 = {
  data: QueryResponse
  status: 200
}

export type executeQueryResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type executeQueryResponseSuccess = (executeQueryResponse200) & {
  headers: Headers;
};
export type executeQueryResponseError = (executeQueryResponseDefault) & {
  headers: Headers;
};

export type executeQueryResponse = executeQueryResponseSuccess

export const getExecuteQueryUrl = (params?: ExecuteQueryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/sorm/query?${stringifiedParams}` : `/auth/v1/sorm/query`
}

/**
 * @summary Execute a query
 */
export const executeQuery = async (queryRequest: QueryRequest,
    params?: ExecuteQueryParams, options?: Parameters<typeof customFetch>[1]): Promise<executeQueryResponse> => {

  return customFetch<executeQueryResponse>(getExecuteQueryUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(queryRequest)
  }
);}





export const getExecuteQueryMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof executeQuery>>, TError,{data: QueryRequest;params?: ExecuteQueryParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof executeQuery>>, TError,{data: QueryRequest;params?: ExecuteQueryParams}, TContext> => {

const mutationKey = ['executeQuery'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof executeQuery>>, {data: QueryRequest;params?: ExecuteQueryParams}> = (props) => {
          const {data,params} = props ?? {};

          return  executeQuery(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ExecuteQueryMutationResult = NonNullable<Awaited<ReturnType<typeof executeQuery>>>
    export type ExecuteQueryMutationBody = QueryRequest
    export type ExecuteQueryMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Execute a query
 */
export const useExecuteQuery = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof executeQuery>>, TError,{data: QueryRequest;params?: ExecuteQueryParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof executeQuery>>,
        TError,
        {data: QueryRequest;params?: ExecuteQueryParams},
        TContext
      > => {
      return useMutation(getExecuteQueryMutationOptions(options), queryClient);
    }
    export type queryPermissionsResponse200 = {
  data: QueryPermissionsResponse
  status: 200
}

export type queryPermissionsResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type queryPermissionsResponseSuccess = (queryPermissionsResponse200) & {
  headers: Headers;
};
export type queryPermissionsResponseError = (queryPermissionsResponseDefault) & {
  headers: Headers;
};

export type queryPermissionsResponse = queryPermissionsResponseSuccess

export const getQueryPermissionsUrl = () => {




  return `/auth/v1/sorm/query-permissions`
}

/**
 * Accepts the same body as /auth/v1/sorm/query and reports the caller's missing schema permission requirements without executing the query or returning SQL. Requirements preserve alternative grants and scope checks. This does not check row-level access, pricing entitlements, or permissions that only filter payload variants. Invalid queries remain errors.
 * @summary Report missing query permissions
 */
export const queryPermissions = async (queryRequest: QueryRequest, options?: Parameters<typeof customFetch>[1]): Promise<queryPermissionsResponse> => {

  return customFetch<queryPermissionsResponse>(getQueryPermissionsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(queryRequest)
  }
);}





export const getQueryPermissionsMutationOptions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof queryPermissions>>, TError,{data: QueryRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof queryPermissions>>, TError,{data: QueryRequest}, TContext> => {

const mutationKey = ['queryPermissions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof queryPermissions>>, {data: QueryRequest}> = (props) => {
          const {data} = props ?? {};

          return  queryPermissions(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type QueryPermissionsMutationResult = NonNullable<Awaited<ReturnType<typeof queryPermissions>>>
    export type QueryPermissionsMutationBody = QueryRequest
    export type QueryPermissionsMutationError = ErrorType<HumaAPIError>

    /**
 * @summary Report missing query permissions
 */
export const useQueryPermissions = <TError = ErrorType<HumaAPIError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof queryPermissions>>, TError,{data: QueryRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof queryPermissions>>,
        TError,
        {data: QueryRequest},
        TContext
      > => {
      return useMutation(getQueryPermissionsMutationOptions(options), queryClient);
    }
